import routes from './dashboard.routes';

export const dashboardModule = {
    routes
};